class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.error = this.querySelector('[data-product-error]');
    this.submitButton = this.querySelector('[type="submit"]');
    this.form?.addEventListener('submit', (event) => this.submit(event));
    this.form?.addEventListener('change', () => this.syncVariant());
  }
  syncVariant() {
    const optionInputs = [...this.form.querySelectorAll('[data-option-input]:checked')];
    if (!optionInputs.length) return;
    const selectedOptions = optionInputs.map((input) => input.value);
    const variants = JSON.parse(this.querySelector('[data-variants-json]')?.textContent || '[]');
    const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
    if (!variant) return;
    this.form.querySelector('[name="id"]').value = variant.id;
    this.submitButton.disabled = !variant.available;
    this.submitButton.querySelector('[data-submit-label]').textContent = variant.available ? 'Add to basket' : 'Sold out';
    const price = this.closest('.product-info')?.querySelector('.price__current');
    if (price) price.textContent = new Intl.NumberFormat('en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' }).format(variant.price / 100);
    const image = document.querySelector('[data-product-main-image]');
    if (image && variant.featured_image?.src) {
      image.src = variant.featured_image.src;
      image.srcset = '';
      image.alt = variant.featured_image.alt || '';
    }
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
  }
  async submit(event) {
    event.preventDefault();
    this.error.textContent = '';
    this.submitButton.disabled = true;
    this.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This item could not be added.');
      const drawer = document.querySelector('cart-drawer');
      if (drawer) await drawer.refresh(true);
      else window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      window.themeAnnounce?.('Added to basket');
    } catch (error) { this.error.textContent = error.message; this.error.focus(); }
    finally { this.submitButton.disabled = false; this.removeAttribute('aria-busy'); }
  }
}
customElements.define('product-form', ProductForm);
